
<template lang="pug">
  a.sidecart__slider(v-if="item" && "item.active === 'true'",:href="item.url")
    .sidecart__slider__image-wrapper
      .sidecart__slider__image-container
        img.sidecart__slider__image(:src="item.image | image('220x')" :alt="item.title")
      p.sidecart__slider__title {{ item.title | truncate(12) }}
    .sidecart__slider__content
      .sidecart__slider__header
        .sidecart__slider__info
          div.sidecart__slider__list 
            p.sidecart__slider__option(v-if="item.size") {{ `${item.size}`.toLowerCase() }}
            p.sidecart__slider__option(v-if="item.color") {{ `${item.color}`.toLowerCase() }}
      .sidecart__slider__details
        p.sidecart__slider__price
          span.sidecart__slider__price--compare-at.p-s(v-if="item.compare_at_price") {{ item.compare_at_price | money }}
          span.p-m {{ item.price | money }}
</template>

<script>

  export default {
    name: 'SidecartRelatedItem',
    props: {
      item: Object,
      line: Number
    },
    computed: {
      isGiftWithPurchase () {
        return Boolean(this.item.properties && this.item.properties._gwp)
      },
    },    
    filters: {
        truncate: function(data,num){
            const reqdString = 
              data.split("").slice(0, num).join("");
            return reqdString;
        }
    },
    methods: {
      addToCart(item) {
        let variantId = item.variant_id

        let addProduct = {
          id: variantId,
          quantity: 1
        }

        if (addProduct.id) {
          this.adding = true
          this.$store.dispatch('cart/addItem', addProduct)
            .then(() => {
              item.active = "false";
            })
            .then(() => this.$store.dispatch('products/addProduct', item.handle));

        } else {
          console.error('Cannot add to cart, invalid product ID'); 
          this.$store.dispatch('toast/send', { text: 'Could not add this product to your cart', type: 'error' })
        }

      }
      
    }

  }
</script> 